// Module
var code = "<mn-procedure-table details=\"vm.item.details\" has-price=\"false\" has-code=\"false\" has-qte=\"false\" readonly=\"true\"\n                    flex></mn-procedure-table>";
// Exports
module.exports = code;